import React, { useState } from 'react'
import { trackEvent } from 'components/analytics'

import { Popover } from 'react-tiny-popover'
import Ripples from 'react-ripples'

import { MdFavoriteBorder } from '@react-icons/all-files/md/MdFavoriteBorder'
import { MdFavorite } from '@react-icons/all-files/md/MdFavorite'

import { loadState, saveState } from '../localStorage'

const SavedList = (props) => {
  const { showBadge, post } = props
  let appLink = 'https://app.vibemap.com/details/'

  const [open, setOpen] = useState(false)

  // TODO: Make this work for guides and places
  // Look at the mobile implementation
  let savedGuides = loadState('savedGuides')
  if (!savedGuides) savedGuides = []

  const [saved, setSaved] = useState(false)
  const foundIndex = post && savedGuides && savedGuides.length > 0
    ? savedGuides.findIndex(obj => obj?.id === post?.id)
    : -1

  const numSaved = savedGuides ? savedGuides.length : 0

  const handleSave = (e, guide) => {
    e.preventDefault()
    e.stopPropagation()

    setSaved(!saved)

    if (!saved) {
      // TODO: Also add Google Analytics
      savedGuides.push(guide)
      trackEvent('Saved', guide)
    } else {
      savedGuides.splice(foundIndex, 1)
    }
    saveState(savedGuides, 'savedGuides')
  }

  const savedList = savedGuides
    ? <ul className='savedList'>
      {savedGuides.map(guide => {
        if (guide) {
          return (
            <li key={guide.slug}>
              <a href={guide.seo.opengraphUrl} target='_blank'>
                <img src={guide.featuredImage.node.mediaItemUrl} loading='lazy' />
                <div>
                  <h3>{guide.title}</h3>
                  <span>{guide.categories.nodes[0].name}</span>
                </div>
              </a>
            </li>
          )
        }
      }
      )}
    </ul>
    : <div>You have not saved any places.</div>

  return (
    <>
      {showBadge && savedGuides && (
        <span
          className='badge'
          floating
          color='violet'
          size='tiny'
          style={{
              right: '1rem',
              top: '3rem',
              maxWidth: '1.8rem'
          }}
        >
          {numSaved}
        </span>
      )}

      {true &&
        <Popover
        className={'savedList'}
        isOpen={open}
        content={savedList}
        padding={12}
        positions={['bottom', 'right']}
        >
        <Ripples>
          <button
            className={'button ui basic secondary'}
            onClick={(e) => handleSave(e, post)}
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
            style={{ height: '4.4rem', padding: '1rem' }}>
            {saved
              ? <MdFavorite size='1.8em' />
              : <MdFavoriteBorder size='1.8em' />
            }

          </button>
        </Ripples>
      </Popover>
      }


    </>
  )
}

SavedList.defaultProps = {
  showBadge : false
}

export default SavedList
